module.exports = __webpack_public_path__ + "img/info1ss.5cf51ac7.jpg";